import { combineReducers, Reducer } from 'redux';
import { submitChallengeReducer } from '&features/submitChallenge/submitChallenge.slice';
import { challengesReducer } from '&features/challenges/challenges.slice';
import { themeDetailsReducer } from '&features/themeDetails/themeDetails.slice';
import { challengeDetailsReducer } from '&features/challengeDetails/challengeDetails.slice';

const createRootReducer = (routerReducer: Reducer) =>
	combineReducers({
		router: routerReducer,
		submitChallenge: submitChallengeReducer,
		challenges: challengesReducer,
		themeDetails: themeDetailsReducer,
		challengeDetails: challengeDetailsReducer,
	});
export default createRootReducer;
